<style lang="scss" scoped>
.otpInput {
  direction: ltr;
}
</style>

<template>
  <v-layout v-if="dialog" row justify-center>
    <!-- :fullscreen="$vuetify.breakpoint.smAndDown" -->
    <v-dialog v-model="dialogState" persistent max-width="400" height="100">
      <v-card>
        <v-card-title class="headline">
          <v-layout row wrap justify-center align-center>
            <v-flex shrink>
              {{ content.email_dialog.title }}
            </v-flex>
            <!-- <v-flex shrink>
              <v-btn text icon color="black" @click="$emit('closeDialog')">
                <Icon icon="mdiClose" />
              </v-btn>
            </v-flex> -->
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout class="mt-7" v-if="!loading" row wrap justify-center>
            <v-flex xs12 v-if="attemptsCount == 5">
              {{ content.email_dialog.body6 }}<br />
              {{ content.email_dialog.body7 }}<br />
              {{ content.email_dialog.body8 }}<br />
              <v-layout row wrap justify-center class="pa-8">
                <!-- <v-btn color="switchq" outlined @click="confirmDialog = true">{{
                  content.confirm
                }}</v-btn> -->
                <v-btn color="danger" outlined @click="cancelDialog">{{
                  content.confirm
                }}</v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs12 v-if="cancel && attemptsCount < 5">
              <v-flex xs12>
                {{ content.email_dialog.body4 }}<br />
                {{ content.email_dialog.body5 }}<br />
                <v-layout row wrap justify-space-between class="pa-8">
                  <v-btn color="switchq" outlined @click="cancelDialog">{{
                    content.cancel
                  }}</v-btn>
                  <v-btn color="danger" outlined @click="cancel = false">{{
                    content.back
                  }}</v-btn>
                </v-layout>
              </v-flex>
            </v-flex>
            <v-flex xs12 v-if="!cancel && attemptsCount < 5">
              {{ content.email_dialog.body1 }}<br />
              {{ content.email_dialog.body2 }}.<br />
              {{ content.phone_dialog.body3 }}<br />
              <v-form
                @submit.prevent="
                  type == 'whatsapp' ? verifyCode : verifyEmailCode
                "
                ref="verifyCodeForm"
                class="mt-2 mb-n4"
              >
                <v-layout row wrap justify-center class="pt-8 py-8">
                  <v-otp-input
                    class="otpInput"
                    v-model="verification_code"
                    length="6"
                    type="number"
                  ></v-otp-input>
                  <v-flex
                    v-show="incorrect"
                    xs12
                    class="text-center mb-3 subheading orange--text text--darken-2"
                  >
                    {{ incorrect }}
                  </v-flex>
                  <v-layout row wrap justify-center class="pt-4 px-4">
                    <v-btn color="danger" outlined @click="cancel = true">{{
                      content.cancel
                    }}</v-btn>
                  </v-layout>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="loading && !error"
            row
            wrap
            justify-center
            class="mb-5 mt-5"
          >
            <v-flex xs12 class="text-center mb-3 mt-5 subheading">
              {{ content.phone_dialog.checking }}
            </v-flex>
            <v-progress-circular
              class="mb-8 mt-12"
              :size="70"
              color="purple"
              indeterminate
            ></v-progress-circular>
          </v-layout>
          <!-- <v-layout v-if="error" row wrap justify-center class="mb-3">
            <v-flex xs12 class="text-center mb-3 title warning--text">
              {{ error }}
            </v-flex>
          </v-layout> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Lang from "@/helpers/lang";
import axios from "@/plugins/axios";
export default {
  name: "emailConfirmationDialog",
  props: ["dialog"],
  data: () => ({
    loading: false,
    resendSMS: 0,
    resendSMSInterval: null,
    verification_code: null,
    error: null,
    incorrect: null,
    dialogState: false,
    confirmDialog: null,
    cancel: false,
    attemptsCount: 0,
  }),
  created() {
    this.locale = Lang.get();
    this.setLang();
    this.setRules();
  },
  mounted() {
    // this.dialogState = this.dialog;
  },
  watch: {
    // attemptsCount() {
    //   if (this.attemptsCount >= 5) {
    //     // this.cancel = true;
    //     this.cancelDialog = true;
    //   }
    // },
    dialog(val) {
      if (val) {
        this.dialogState = true;
        this.$store.dispatch("user/editEmailNotifications", {
          email: this.$store.getters["user/user"].email,
        });
        this.startInterval();
      } else {
        this.dialogState = false;
        this.cancelInterval();
      }
    },
    verification_code(code) {
      if (code && code.length === 6) {
        this.incorrect = null;
        this.verifyEmailCode();
      }
    },
  },
  methods: {
    startInterval() {
      this.resendSMS = 60;
      this.resendSMSInterval = setInterval(() => {
        this.resendSMS--;
        if (this.resendSMS === 0) {
          clearInterval(this.resendSMSInterval);
          this.resendSMSInterval = null;
        }
      }, 1000);
    },
    cancelInterval() {
      this.verification_code = null;
      clearInterval(this.resendSMSInterval);
      this.resendSMSInterval = null;
      setTimeout(() => {
        this.loading = false;
        this.error = null;
      }, 500);
    },
    async cancelDialog() {
      await this.$store.dispatch("user/cancelEmailNotifications", {
        email: 0,
      });
      this.dialogState = false;
      this.attemptsCount = 0;
      this.cancel = false;
      this.confirmDialog = false;
    },
    verifyEmailCode() {
      if (this.$refs.verifyCodeForm.validate()) {
        this.loading = true;
        const PATH = "user/notifications/mail/otp";
        let data = {
          code: this.verification_code,
          email: this.$store.getters["user/user"].email,
        };
        axios
          .post(PATH, data)
          .then(async (res) => {
            if (res.status == 200) {
              this.attemptsCount = 0;
              await this.$store.dispatch("user/toggleEmail");
              this.$emit("close");
            } else if (res.status == 201) {
              this.verification_code = "";
              this.loading = false;
              await this.$store.dispatch("user/toggleEmailFalse");
            }
          })
          .catch(async (err) => {
            if (err.response.status == 418) {
              this.attemptsCount++;
              this.verification_code = "";
              this.loading = false;
              this.incorrect = this.$t("wrong-code");
              await this.$store.dispatch("general/setAlert", {
                type: "failed",
                msg: "wrong-code",
              });
              this.$emit("failedEmailValidate");
              // this.error = this.content.errors.invalid;
            }
            if (err.response.status == 429) {
              this.attemptsCount = 5;
              this.error = this.content.errors.invalid;
              this.incorrect = this.content.errors.incorrect;
            }
            if (err.response.data.code) {
              // this.incorrect = this.content.errors.incorrect;
              if (err.response.data.code == 19.3) {
                this.error = this.content.errors.passedtime;
              } else if (err.response.data.code == 19.2) {
                this.error = this.content.errors.verified;
              } else if (err.response.data.code == 19.4) {
                // console.log("im here incorrect");

                this.incorrect = this.content.errors.incorrect;
              } else {
                this.error = this.content.errors.invalid;
              }
            }
            this.verification_code = "";
            this.loading = false;
          });
      }
    },
    setRules() {
      this.rules = {
        phone_code: [
          (v) => !!v || this.content.rules.phonecode[0],
          (v) => (v && v.length === 6) || this.content.rules.phonecode[1],
        ],
      };
    },

    setLang() {
      if (this.locale == "en") {
        this.content = {
          phone: "Mobile Phone",
          email_dialog: {
            title: "Validating Email Address",
            body1: "Your email address should be validated.",
            body2: "A verification code has been sent to your email address",
            body3: "Please insert here the code that you have received:",
            body4:
              "Canceling the action will cause deactivasion of email notifications.",
            body5: '"Back" to return, "Cancel" to close the window.',
            body6: "You have tried too many times!",
            body7: "The email notifications are now deactivated.",
            body8:
              "You can try turning it on and get verified again in a couple of minutes.",
          },
          phone_dialog: {
            title: "Validating Phone Number",
            body1:
              "A verification message has been sent to the number you entered",
            // body2: "The message contains a short, one-time code.",
            body2: "Please fill the received code:",
            code: "verification code",
            checking: "validating verification code",
            notreceived: "Did not receive the code?",
            resend: "Send a new code",
            possible: "Will be possible in",
            seconds: "seconds",
          },
          rules: {
            phonecode: [
              "You must enter the code",
              "The code must be 6 digits long",
              "The code is invalid",
            ],
          },
          errors: {
            passedtime: "Too much time has passed, please try again.",
            verified: "This phone number has already been confirmed.",
            invalid: "The request is invalid.",
            incorrect: "The code is incorrect.",
          },

          edit: "Edit",
          save: "Save",
          cancel: "Cancel",
          // close: "Cancel",
          confirm: "Confirm",
          back: "Back",
        };
      } else if (this.locale == "he") {
        this.content = {
          // phone: "טלפון נייד",
          email_dialog: {
            title: "אימות כתובת אימייל",
            body1: "המערכת מצאה כי כתובת האימייל הרשומה דורשת אימות.",
            body2: "הודעת אימות נשלחה לכתובת האימייל שלך ",
            body3: "אנא הזן פה את הקוד שקיבלת:",
            body4: "ביטול הפעולה תגרום לביטול התראות האימייל למשתמש זה.",
            body5: '"חזור" להמשך אימות, "ביטול" לסגירת החלון.',
            body6: "ניסית יותר מידי פעמים!",
            body7: "התראות המייל אינן זמינות כעט.",
            body8:
              "ניתן לנסות להפעיל את ההתראות ולעבור תהליך אימות מחדש בעוד מספר דקות.",
          },
          phone_dialog: {
            title: "אימות מספר טלפון",
            body1: "הודעת אימות נשלחה למספר שהזנת ",
            body2: "ההודעה מכילה קוד קצר וחד פעמי.",
            body3: "אנא הזן פה את הקוד שקיבלת:",
            code: "קוד אימות",
            checking: "קוד האימות בבדיקה",
            notreceived: "לא קיבלת את הקוד?",
            resend: "שליחת הודעה חדשה",
            possible: "יתאפשר בעוד",
            seconds: "שניות",
          },
          errors: {
            passedtime: "עבר יותר מידי זמן, אנא נסה שנית.",
            verified: "מספר הטלפון הזה כבר אושר.",
            invalid: "הבקשה אינה תקינה.",
            incorrect: "הקוד אינו נכון.",
          },

          rules: {
            phonecode: [
              "חובה להזין את הקוד",
              "הקוד חייב להיות באורך של 6 ספרות",
              "הקוד לא תקין",
            ],
          },

          edit: "עריכה",
          save: "שמירה",
          cancel: "ביטול",
          confirm: "אישור",
          close: "סגירה",
          back: "חזור",
        };
      }
    },
  },
};
</script>
